import { useEffect, useMemo, useRef } from 'react';
import { useExperience, phaseIndex } from '@/store/experience';

// Cinematic 2D version for devices without WebGL: sky gradient, drifting cloud layers,
// scroll parallax and the coin footage masked into the atmosphere.
export function Fallback2D({ cloudCanvas }) {
  const phase = useExperience((s) => s.phase);
  const frame = useExperience((s) => s.frame);
  const layersRef = useRef([]);
  const url = useMemo(() => (cloudCanvas ? cloudCanvas.toDataURL('image/png') : null), [cloudCanvas]);
  const clouds = useMemo(() => Array.from({ length: 14 }, (_, i) => ({ id: i, x: (i * 37) % 100, y: (i * 53) % 100, s: 220 + ((i * 97) % 380), depth: 0.3 + ((i * 7) % 10) / 12, tile: i % 4 })), []);
  const showCoin = phaseIndex(phase) >= phaseIndex('COIN_REVEAL');
  const website = phaseIndex(phase) >= phaseIndex('WEBSITE');

  useEffect(() => {
    let raf;
    const loop = () => {
      layersRef.current.forEach((el, i) => { if (el) el.style.transform = `translate3d(0, ${-frame.scroll * 1400 * clouds[i].depth}px, 0)`; });
      raf = requestAnimationFrame(loop);
    };
    loop();
    return () => cancelAnimationFrame(raf);
  }, [frame, clouds]);

  return (
    <div className="fixed inset-0 z-0 overflow-hidden" style={{ background: 'linear-gradient(180deg, #061a3d 0%, #1c4f9c 55%, #8fc1ec 100%)' }} data-testid="fallback-2d">
      {url && clouds.map((c, i) => (
        <div key={c.id} ref={(el) => { layersRef.current[i] = el; }} className="absolute" style={{ left: `${c.x}%`, top: `${c.y}%`, width: c.s, height: c.s, opacity: 0.5 + c.depth * 0.4 }}>
          <div className="w-full h-full float-slow" style={{ backgroundImage: `url(${url})`, backgroundSize: '200% 200%', backgroundPosition: `${(c.tile % 2) * 100}% ${Math.floor(c.tile / 2) * 100}%`, animationDelay: `${-i * 1.1}s`, filter: `blur(${(1 - c.depth) * 3}px)` }} />
        </div>
      ))}
      {showCoin && (
        <video src="/assets/coin.mp4" autoPlay muted loop playsInline className={`absolute transition-all duration-[1500ms] ease-in-out ${website ? 'right-[-4vw] bottom-[-6vh] w-[34vmin]' : 'left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[70vmin]'}`}
          style={{ aspectRatio: '512/910', objectFit: 'cover', WebkitMaskImage: 'radial-gradient(ellipse 42% 46% at 50% 50%, #000 40%, transparent 100%)', maskImage: 'radial-gradient(ellipse 42% 46% at 50% 50%, #000 40%, transparent 100%)', mixBlendMode: 'screen', opacity: 0.95 }} data-testid="fallback-coin-video" />
      )}
    </div>
  );
}
